
<div class="em-block form-style">
  <div class="em-child">
    <h3>{{folder.name}}</h3>

    <template v-if="isEditing">
      <label for="link-name">Link Name</label>
      <input v-model="link.name" type="text" id="link-name">
    </template>

    <template v-else>
      <h4>Link Name</h4>
      <p>{{link.name}}</p>
    </template>

    <h5>Link to...</h5>
    <div class="em-child">

      <row v-if="showBackButton">
        <column>
          <button @click="resetUi" class="btn-link"><span class="icon arrow-chevron left"></span> Go back</button>
        </column>
      </row>

      <row class="quickmenu-links">
        <template v-for="configRow in selectedBuilderConfigsWithLevelInRows">
          <bookmark-link-builder-node
            v-for="({config, level}, index) in configRow"
            :key="`${level}-${index}`"
            :builder-config="config"
            :level="level"
            :isEditing="isEditing"
            @showBackButton="showBackButton = true"
          ></bookmark-link-builder-node>
        </template>
      </row>
    </div>

    <div class="cta">
      <template v-if="isEditing">
        <button @click="cancelClicked" type="button" class="btn red outline block">Cancel</button>
        <button @click="saveClicked" type="button" class="btn green block" :disabled="!saveEnabled">Save</button>
      </template>
      <template v-else>
        <button @click="editClicked" type="button" class="btn grey-to-blue block">
          <span class="icon pencil"></span>
          Edit
        </button>
      </template>
    </div>
  </div>
</div>
